import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import {
  setTheAttendanceLocationAction,
  setTheAttendanceLocationDeleteAction,
  setTablePositionPersist
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import Delete from "../../AppComponent/Popup/Delete";
import _ from "lodash";
import AttendanceLocationCrud from "./AttendanceLocationCrud";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";

const AttendanceLocation = () => {
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
   const TablePositionPersist = useSelector(state=>state.PreviousPagePosition.TablePositionPersist)
  
  const [LeaveCreate, setLeaveCraete] = useState(false);
  const [DeletePopup, setDeletepopup] = useState(false);
  const [DeleteId, setDeleteID] = useState();
  const [EditPopupCall, setEditPopup] = useState(false);
  const [EditID, setEditId] = useState();
const [dtpageindex, setdtPageindex] = useState(
    TablePositionPersist?.Overall_attendance_locations?.page == undefined
      ? 1
      : TablePositionPersist.Overall_attendance_locations.page
  );


  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);


  const [search,setsearch] = useState(
      TablePositionPersist?.Overall_attendance_locations?.search == undefined ||
      TablePositionPersist?.Overall_attendance_locations?.search == ""
        ? ''
        : TablePositionPersist?.Overall_attendance_locations?.search
    ); 

  const state = useSelector((state) => state);
  const [sno, setsno] = useState(0);

  useEffect(() => {
    const payloads = {
      search: search,
      page_size: 20,
      page: dtpageindex,
    };
    dispatch(setTheAttendanceLocationAction(payloads));
        dispatch(
              setTablePositionPersist({ data: payloads, pageName: "Overall_attendance_locations" })
            );
  }, [dtpagesize, dtpageindex, search]);
  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    setdtPageindex(arg);
  };
  const columns = useMemo(
    () => [
      {
        Header: "S.no",
        accessor: "",
        Cell: (row) => {
          return <p>{Number(sno + row.row.index + 1)}</p>;
        },
      },
      {
        Header: "Place",
        accessor: "",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                {row.row.original.place_name != null &&
                row.row.original.place_name != "" ? (
                  <span>{row.row.original.place_name}</span>
                ) : (
                  <span>{"---"} </span>
                )}
              </span>
            </>
          );
        },
      },
      {
        Header: "Latitude",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                {row.row.original.latitude != null &&
                row.row.original.latitude != "" ? (
                  <span>{row.row.original.latitude}</span>
                ) : (
                  <span>{"---"} </span>
                )}
              </span>
            </>
          );
        },
      },
      {
        Header: "Longitude",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                {row.row.original.longitude != null &&
                row.row.original.longitude != "" ? (
                  <span>{row.row.original.longitude}</span>
                ) : (
                  <span>{"---"} </span>
                )}
              </span>
            </>
          );
        },
      },

      {
        Header: "Actions",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <div
                class="actions"
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: "5px",
                }}
              >
                <button
                  className=" btn Status"
                  onClick={(e) => {
                    setEditId(row.row.original.id);
                    setEditPopup(true);
                  }}
                  component="span"
                >
                  <span className="OuterActionSpan">
                  <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>
                    <span className="ActionsList"> Edit </span>
                  </span>
                </button>
                <button
                  type="button"
                  class="btn Status"
                  onClick={(e) => {
                    setDeleteID(row.row.original.id);
                    setDeletepopup(true);
                  }}
                >
                  <span className="OuterActionSpan">
                  <span  className="EditImages">
                    <img src={DeleteImages}/>
                  </span>
                    <span className="ActionsList"> Delete </span>
                  </span>
                </button>
              </div>
            </>
          );
        },
      },
    ],
    [sno]
  );

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 500),
    []
  );

  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);
  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const HandleDeletes = () => {
       setdtPageindex(1)
         const payloads_tocall = {
          search: "",
          page_size: 20,
          page: 1,
          };
          dispatch(setTablePositionPersist({data:payloads_tocall,pageName:"Overall_attendance_locations"}))
          
    if (DeleteId != undefined) {
      const payload = {
        DeleteId: DeleteId,
        currentPage: dtpageindex,
      };
      dispatch(
        setTheAttendanceLocationDeleteAction(payload, setDeletepopup(false))
      );
    }
  };

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Attendance Location</h3>
          </div>
          <div className="Add-User col-sm-5">
            <button
              onClick={(e) => {
                setLeaveCraete(true);
                setEditId("");
              }}
              className="ButtonCSS"
            >
              Create
            </button>
          </div>
        </div>
        <br />

        <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
          <ReactTable
            data={state.AttendanceLocationSliceCall.AttendanceLocationData}
            columns={columns}
            totalItems={state.AttendanceLocationSliceCall.Total_Count}
            currentPage={currentPage}
            onChange={tochange}
            pagesize={pagesize}
            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
            pageindex={pageindex}
            datacount={state.AttendanceLocationSliceCall.Total_Count}
            Filter={true}
            NoFilter={true}
            setsno={setsno}
            sno={sno}
            id={"spe"}
                              searchVal={TablePositionPersist?.Overall_attendance_locations?.search == "" || TablePositionPersist?.Overall_attendance_locations?.search ==undefined? "":TablePositionPersist.Overall_attendance_locations.search}
              search_key={true}
          />
        </div>
      </div>
      {LeaveCreate ? (
        <AttendanceLocationCrud
          show={LeaveCreate}
          setShow={setLeaveCraete}
          currentPage={dtpageindex}
          search={search}
        />
      ) : null}
      {EditPopupCall && EditID != undefined ? (
        <AttendanceLocationCrud
          show={EditPopupCall}
          setShow={setEditPopup}
          currentPage={dtpageindex}
          EditID={EditID}
          search={search}
        />
      ) : null}
      {DeletePopup ? (
        <Delete
          show={DeletePopup}
          setShow={setDeletepopup}
          onSubmit={HandleDeletes}
          Content={"Do you want to delete the Place"}
        />
      ) : null}
    </>
  );
};

export default AttendanceLocation;
